import Cart from './cart/Cart';

var prevScrollPosition = 0;
var isHeaderFixed = false
require('../../bootstrap')

window.onload = () => {
    new Cart();
    swiss_ui();
}

export default function swiss_ui() {
    handleSwissUiPageScroll();
    registerSwissUiEventListeners();
    if (getFullScreenLoader()) {
        setTimeout(() => {
            getFullScreenLoader().classList.toggle('hideFullScreenLoader')            
        }, 1000);
    }
}

function getTopHeaderBar() {
    return document.getElementById('headerSection');
}

function getTopHeaderBarLanguageDropDown() {
    return document.getElementById('languageDropDownMenu');
}

function getMobileDrawerCloseIcon() {
    return document.getElementById('mobileDrawerCloseIcon');
}

function getMobileDrawer() {
    return document.getElementById('mobileSideDrawer');
}

function getMobileSideDrawerContent() {
    return document.getElementById('mobileSideDrawerContent');
}

function getMobileHeaderMenuIcon() {
    return document.getElementById('mobileHeaderMenuIcon');
}

function getMenuOverlay() {
    return document.getElementById('menuOverlay');
}

function getFullScreenLoader() {
    return document.getElementById('fullScreenLoader');
}

function getDarkHeaderLogo() {
    return document.getElementById('darkHeaderLogo');
}

function getLightHeaderLogo() {
    return document.getElementById('lightHeaderLogo');
}


function registerSwissUiEventListeners() {
    window.addEventListener('scroll', handleSwissUiPageScroll);
    getMobileDrawerCloseIcon().addEventListener('click', handleMobileDrawerCloseIconClick);
    getMobileHeaderMenuIcon().addEventListener('click', handleMobileDrawerCloseIconClick);
}

function handleSwissUiPageScroll() {
    var currentScrollPos = window.pageYOffset;
    handleMainHeaderScrolling(currentScrollPos);
}

function handleMainHeaderScrolling(currentScrollPos) {
    const navigationBar = getTopHeaderBar();
    const headerMode = navigationBar.getAttribute('data-headerMode');
    const lightHeaderLogo = getLightHeaderLogo();
    const darkHeaderLogo = getDarkHeaderLogo();

    const width = window.innerWidth;
    const isMobileView = width < 992;


    if (headerMode !== 'fix' && headerMode === "scrollFix" && headerMode !== 'static' && navigationBar) {
        if (200 < currentScrollPos) {
            if (!isHeaderFixed) {
                toggleNavigationBarClasses(navigationBar, lightHeaderLogo, darkHeaderLogo, isMobileView, headerMode);
                isHeaderFixed = true
            }
            prevScrollPosition = currentScrollPos;
        } else {
            if (isHeaderFixed) {
                toggleNavigationBarClasses(navigationBar, lightHeaderLogo, darkHeaderLogo, isMobileView, headerMode);
                isHeaderFixed = false
            }
        }

        if (isMobileView && darkHeaderLogo.classList.contains('d-none')) {
            darkHeaderLogo.classList.toggle('d-none')
            lightHeaderLogo.classList.toggle('d-none')
        }

    } else {
        if((headerMode === 'static' || headerMode === 'fix' ) && darkHeaderLogo.classList.contains('d-none')){
            toggleHeaderLogo(darkHeaderLogo, lightHeaderLogo)
        }
    }
}

function toggleNavigationBarClasses(navigationBar, lightHeaderLogo, darkHeaderLogo, isMobileView, headerMode) {
    navigationBar.classList.toggle('fixedHeaderSection')
    navigationBar.classList.toggle('headerSection')
    navigationBar.classList.toggle('dark-theme')
    navigationBar.classList.toggle('light-theme')

    if (lightHeaderLogo && darkHeaderLogo && !isMobileView) {
        toggleHeaderLogo(darkHeaderLogo, lightHeaderLogo)
    }
}

function toggleHeaderLogo(darkHeaderLogo, lightHeaderLogo) {
    darkHeaderLogo.classList.toggle('d-none')
    lightHeaderLogo.classList.toggle('d-none')
}

function handleMobileDrawerCloseIconClick() {
    getMobileDrawer().classList.toggle('hideMobileSideDrawer')
    getMenuOverlay().classList.toggle('showMenuOverlay')
}
